import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { TabsModule } from 'primeng/tabs';
import { filter, map } from 'rxjs';

@Component({
    selector: 'app-profile',
    imports: [TabsModule, RouterLink, RouterOutlet],
    templateUrl: './profile.component.html',
    styleUrl: './profile.component.scss'
})
export class ProfileComponent {

  private readonly router = inject(Router);

  items = [
    {
      label: 'Profil',
      icon: 'pi pi-user-edit',
      routerLink: 'info'
    },
    {
      label: 'Sécurité',
      icon: 'pi pi-shield',
      routerLink: 'security'
    },
    {
      label: 'Authentification TOTP',
      icon: 'pi pi-mobile',
      routerLink: 'totp'
    },
  ];

  /** Onglet actif = dernier segment de l'URL (info / security / totp). */
  activeTab = toSignal(
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(() => this.currentSegment())
    ),
    { initialValue: this.currentSegment() }
  );

  private currentSegment(): string | undefined {
    return this.router.url.split(/[?#]/)[0].split('/').pop();
  }

}
